import Vue from 'vue';
import Vuex from 'vuex';
import auth from './auth';
import neopass from './neopass';
import template from './pageTemplate';
import jobDescription from './jobDescription';
import jobs from './jobs';

import permissions from './permissions/permissions';
import roles from './permissions/roles';
import referents from './permissions/referents';
import beneficiariesReferent from './permissions/beneficiariesReferent';
import beneficiaries from './permissions/beneficiaries';
import invites from './permissions/invites';

import cartographiesCollectives from './cartographiesCollectives';
import cartographiesIndividuelles from './cartographiesIndividuelles';
import account from './account';
import app from './app';
import help from './help';
import listMenus from './listMenus';

import curriculumVitae from './curriculumVitae';

import depotDocuments from './depotDocuments';

import rechercheCompetences from './rechercheCompetences';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    neopass,
    template,
    jobDescription,
    jobs,
    permissions,
    roles,
    referents,
    beneficiariesReferent,
    beneficiaries,
    cartographiesCollectives,
    cartographiesIndividuelles,
    account,
    app,
    listMenus,
    help,
    depotDocuments,
    curriculumVitae,
    rechercheCompetences,
    invites,
  }
});
